import React, { useState, useEffect,useCallback } from "react";
import {
  Modal,
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  Grid,
  styled,
  StepConnector,
  stepConnectorClasses,
  CircularProgress,
} from "@mui/material";
import Tick from "./Assets/Images/tick.svg";
import { toast } from "react-toastify";
import { getTenantById, createRequestStatus, logRiskMitigationRequested } from "./api/tenantApi";
import getTenantIdFromURL from "./utils/getTenantIdFromURL";
import { useSelector } from "react-redux";

// TODO: Send Email and create request status

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#E9E9E9",
  zIndex: 1,
  color: "#fff",
  width: 45,
  height: 45,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 3px 6px #00000029",
  ...(ownerState.active && {
    backgroundColor: "#2F3D63",
    boxShadow: "0px 3px 6px #00000029",
    border: "2px solid #5186EC",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#2F3D63",
    boxShadow: "0px 3px 6px #00000029",
  }),
}));

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#2F3D63",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#2F3D63",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 0,
    border: "1px solid #2F3D63",
    backgroundColor: "#2F3D63",
    borderRadius: 1,
  },
}));

const SendRequestModal = ({ open, onClose, fileType, companyInfo, navigationFrom }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    emailAddress: "",
    lastName: "",
    phoneNumber: "",
    customMessage: "",
  });
  const [errors, setErrors] = useState({
    emailAddress: "",
  });
  const [tenantID, setTenantId] = useState(null);
  const currentTenant = useSelector((state) => state.userInfo.tenantId);
    const isAdmin = useSelector((state) => state.userInfo.isAdmin);
    const URLTenant = getTenantIdFromURL();
  
const selectTenantId = useCallback(() => {
    if (isAdmin) setTenantId(URLTenant);
    else setTenantId(currentTenant);
  }, [isAdmin, URLTenant, currentTenant]);

  useEffect(() => {
    selectTenantId();
  }, [selectTenantId]);
  const steps = ["Contact Details", "Custom Message"];


  const EMAIL_ADDRESS_REGEX =
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

  const validateEmail = (formData) => {
    if (!formData?.emailAddress?.trim()) {
      return { hasError: true, errorMessage: "Email address is required" };
    }
    if (!EMAIL_ADDRESS_REGEX.test(formData.emailAddress)) {
      return { hasError: true, errorMessage: "The value must be a valid email address" };
    }
    return { hasError: false, errorMessage: "" };
  };

  const handleNext = async () => {
    try {
      setIsLoading(true);
      const tenantData = await getTenantById(tenantID);
      const companyName = companyInfo.name;
      if (activeStep === 1) {
        const result = await fetch('https://us-central1-crediarc-cyp.cloudfunctions.net/createUser', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formData?.emailAddress,
            fullName: `${formData?.firstName} ${formData?.lastName}`,
            title: formData?.phoneNumber || "",
            companyId: companyInfo?.companyId,
            tenantId: tenantID,
            tenant: tenantData?.data?.name || tenantData?.name || "Unknown",
            companyName: companyName,
          }),
        });
        const now = new Date().toISOString();
        const comment = formData.customMessage;
        const email = formData?.emailAddress;
        const phoneNumber = formData?.phoneNumber || "";
        const tenantName = tenantData?.data?.name || tenantData?.name || "Unknown";
        const companyId = companyInfo?.companyId;

        try {
          const dbResponse = await createRequestStatus({
            tenantId: tenantID,
            companyName: companyName,
            tenantName: tenantName,
            companyId: companyId || "",
            requestType: "Mitigation Action",
            requestStatus: "sent",
            requestDate: now,
            statusChangeDate: now,
            comments: comment,
            email: email,
            phoneNo: phoneNumber,
          });

          try {
            console.log("Logging Mitigation Request...");
            await logRiskMitigationRequested(companyId, { requestedLimit: companyInfo?.requestedLimit, comment, mitigationType: fileType });
            console.log("Logged Mitigation Request Successfully");
          } catch (error) {
            console.error("Error logging risk mitigation request:", error);
          }
          
          toast.success("Request sent and status saved successfully");
        } catch (dbError) {
          console.error("Error saving request status:", dbError);
          toast.error("Request sent but failed to save status.");
        }

        handleClose(); // Close modal or stepper
      } else {
        // Form validation for email address
        const validationResult = validateEmail(formData);
        if (validationResult.hasError) {
          setErrors({ emailAddress: validationResult.errorMessage });
          toast.error(validationResult.errorMessage);
        } else {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
      }
    } catch (error) {
      toast.error("An error occurred while processing the request.");
      console.error("Error in handleNext:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      handleClose();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleClose = () => {
    onClose();
    setActiveStep(0);
    setFormData({
      firstName: "",
      emailAddress: "",
      lastName: "",
      phoneNumber: "",
      customMessage: "",
    });
  };

  const toTitleCase = (str) => {
    str = `Send ${fileType} Request To ` + str;
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {completed ? (
          <img src={Tick} width={25} alt="" />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              style={{
                color: active ? "#fff" : "#777A82",
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              {icon}
            </span>
          </div>
        )}
      </ColorlibStepIconRoot>
    );
  }

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                margin="normal"
                label="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                margin="normal"
                label="Email Address"
                name="emailAddress"
                value={formData.emailAddress}
                onChange={handleChange}
                required
                error={!!errors.emailAddress}
                helperText={errors.emailAddress}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                margin="normal"
                label="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                margin="normal"
                label="Title"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <Box>
            <Typography variant="h6" gutterBottom>
              Do you want to add a personal message?
            </Typography>
            <TextField
              fullWidth
              margin="normal"
              label="Custom Message"
              name="customMessage"
              value={formData.customMessage}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </Box>
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="contact-modal-title"
      aria-describedby="contact-modal-description"
      sx={{
        backdropFilter: "blur(2px)",
        backgroundColor: "rgb(255, 255, 255, 0.5)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        onClick={(event) => {
          if (event.target === event.currentTarget) {
            handleClose();
          }
        }}
      >
        <Box
          sx={{
            width: 600,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#2F3D63",
            borderRadius: "20px",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            id="modal-modal-title"
            component="h2"
            sx={{
              textAlign: "center",
              padding: 2,
              color: "#2F3D63",
            }}
          >
            {toTitleCase(companyInfo.name)}
          </Typography>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<ColorlibConnector />}
            style={{
              background: "#5186EC1A",
              height: "82px",
              width: 600,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconComponent={ColorlibStepIcon}
                  icon={index + 1}
                ></StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 2, width: "100%" }}>
            {renderStepContent(activeStep)}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                disabled={isLoading}
                onClick={handleBack}
                variant="contained"
                sx={{
                  mr: 1,
                  width: "132px",
                  height: "35px",
                  borderRadius: "8px",
                  backgroundColor: "#5186EC",
                }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={isLoading}
                sx={{
                  width: "132px",
                  height: "35px",
                  borderRadius: "8px",
                  backgroundColor: "#5186EC",
                }}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  activeStep === steps.length - 1 ? "Finish" : "Next"
                )}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SendRequestModal;